import React, { useState } from 'react';
import classnames from 'classnames';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';

import Icon from '@hydra/common/components/Icon';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(2.5),
    borderRadius: theme.spacing(1)
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    display: 'block'
  },
  message: {
    paddingTop: theme.spacing(0.75)
  },
  dismissButton: {
    alignSelf: 'flex-start'
  }
}));

interface INotificationBanner {
  icon?: React.ReactNode
  severity?: 'info' | 'success' | 'warning' | 'error'
  variant?: 'filled' | 'outlined'
  dismissable?: boolean
  children?: React.ReactNode
  title?: string | React.ReactNode
  description?: string | React.ReactNode
}

export default function NotificationBanner ({
  icon,
  severity = 'info', // info | success | warning | error
  variant = 'filled', // outlined | filled
  dismissable = false,
  children,
  title,
  description
}: INotificationBanner) {
  const [open, setOpen] = useState(true);
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Collapse in={open}>
      <Alert
        severity={severity}
        variant={variant}
        className={classes.root}
        classes={{
          message: classes.message
        }}
        icon={icon}
        action={dismissable && (
          <IconButton
            aria-label='close'
            color='inherit'
            size='small'
            className={classes.dismissButton}
            onClick={() => {
              setOpen(false);
            }}
          >
            <Icon type='cross' size='sm' color={theme.palette.secondary.main} />
          </IconButton>
        )}
      >
        <>
          {title && (
            <Typography component='span' className={classes.title}>
              {title}
            </Typography>
          )}
          {description && (
            <Typography component='span'>
              {description}
            </Typography>
          )}
          {children}
        </>
      </Alert>
    </Collapse>
  );
}
